import { solarProductAxios } from '@infrastructure/apiService'
import { IEnergyEfficiencyCertificateRepository } from '@modules/energy-efficiency-certificate/domain/energy-efficiency-certificate.repository'

export const energyEfficiencyCertificateService: IEnergyEfficiencyCertificateRepository =
  {
    getOptions: async () => {
      const { data } = await solarProductAxios.get(
        '/private/energy-efficiency-certificates/options'
      )
      return data
    },
  }
